import React, { Component } from 'react';
import "./style.css";

// import Tile from "arc-design/components/tile";
import { 
  // HelpText, 
  QlikClearSelections, 
  QdtComponent 
} from "../../components";

export default class CityProfile extends Component {

  render() {
    return (
    <div className="cityProfile">    
    
      {/* <div className="sectionHeader"> */}
          <div className="intro">
            <div className="Filter">
              <QdtComponent props={{
                id:"4847f134-6fca-48c9-b08d-f3e5e7753141",  //Filter
                height:"50px"
              }}/>
            </div>
            <div className="cityName2">
              {/* <QdtComponent type="QdtKpi" props={{ cols: ["=[zCityCountry_Mode]"] }} /> */}
              <QdtComponent props={{
                id:"KbZhvv",  //
                height:"50px",
                width: "350px"
              }}/>
            </div>
          </div>
          {/* <div className="clear">
              <QlikClearSelections />
          </div> */}
      {/* </div>   */}
       
      {/* <div className="subsectionTitle">Targets on renewable energy or electricity</div> */}

      <div className="chartwithfooter">
        <div className="chart">
          {/* <div className="chartTitle"></div> */}
            <QdtComponent props={{
              id: "a2587c5f-e79f-47cc-a72d-2f5fb8c65749",
              height: "270px", 
              noSelections: true
            }} />
        </div> 
        <div className="footnote">
          <div className="footitem">Data source: CDP 2019</div>   
        </div> 
      </div>
    </div>      

    );
  }
}
